<template>
  <v-app>
    <v-row>
      <v-col cols="12" md="6" class="hidden-sm-and-down">
        <div>
          <v-img src="../assets/reset.svg"> </v-img>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="pa-2 d-flex align-end justify-end">
          <div class="" style="width: 150px">
            <v-img src="../assets/logo.png" width="150" contain></v-img>
          </div>
        </div>
        <v-container fill-height>
          <v-card flat width="500">
            <div class="d-flex justify-center align-center">
              <v-card-text>
                <div>
                  <p class="text-h4 mx-3 font-weight-bold">Reset Passsword</p>
                </div>

                <v-card flat>
                  <v-col cols="12" md="12">
                    <div class="d-flex align-center justify-center">
                      <v-card width="500" flat>
                        <v-form v-model="form" ref="form">
                          <v-col cols="12" md="12" class="py-0">
                            <span class="text-body-1">Code</span>
                            <v-text-field
                              outlined
                              placeholder="Enter Password Reset Code"
                              color="primary"
                              :rules="[rules.required]"
                              type="name"
                              v-model="code"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12" class="py-0">
                            <span class="text-body-1">New Password</span>
                            <v-text-field
                              outlined
                              placeholder="Enter New Password"
                              color="primary"
                              type="name"
                              :rules="[rules.password, rules.required]"
                              v-model="password"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12" class="py-0">
                            <span class="text-body-1">Confirm Password</span>
                            <v-text-field
                              outlined
                              placeholder="Confirm Your Password"
                              color="primary"
                              type="name"
                              :rules="[
                                rules.password,
                                rules.required,
                                passwordConfirmationRule,
                              ]"
                              v-model="confirmPassword"
                            ></v-text-field>
                          </v-col>
                        </v-form>
                        <v-col cols="12" md="12">
                          <div class="">
                            <v-btn
                              color="primary"
                              block
                              large
                              @click="reset()"
                              :loading="loading"
                              :disabled="loading"
                              >Reset Password</v-btn
                            >
                          </div>
                        </v-col>
                      </v-card>
                    </div>
                  </v-col>
                </v-card>
              </v-card-text>
            </div>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    code: "",
    confirmPassword: "",
    password: "",
    loading: false,
    form: false,
    rules: {
      email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
      length: (len) => (v) =>
        (v || "").length >= len || `Invalid character length, required ${len}`,
      required: (v) => !!v || "This field is required",
      password: (value) =>
        (value && value.length >= 6) || "Minimum length is 6 characters",
    },
  }),

  methods: {
    reset() {
      this.loading = true;

      const data = {
        token: this.code,
        password: this.password,
        confirm_password: this.password,
      };
      if (this.$refs.form.validate()) {
        fetch("https://receipt.drecsoft.com/api/auth/reset-password", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((res) => {
            console.log(res);

            this.$router.push("/");
          })
          .catch((e) => {
            console.log(e);

            this.loading = false;
          });
      }
    },
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.password === this.confirmPassword || "Password must match";
    },
  },
};
</script>cr